import React from "react";

export default function DateInput({ label, value, onChange, error }) {
  return (
    <div className="form-group">
      <label>{label}:</label>
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {error && <p className="error-text">{error}</p>}
    </div>
  );
}
